import modalStyle from '@salesforce/retail-react-app/app/theme/components/base/modal'
import {remCalc} from '../../_utils'

export default {
    ...modalStyle,
    baseStyle: {
        modalOverlay: {
            background: 'transparent',
            pointerEvents: 'none',
        },

        closeIcon: {
            boxSize: {base: 'iconsSize.medium', lg: 'iconsSize.large'},
        },
        modalHeader: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: {
                base: 'xxxsmall-1.base',
                md: 'xxxsmall-1.md',
                lg: 'xxxsmall-1.lg',
                xl: 'xxxsmall-1.xl',
            },
            p: remCalc(0),
        },
        modalHeaderTitle: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            textAlign: 'left',
            fontWeight: 'medium',
        },
        checkIconBox: {
            width: remCalc(16),
            height: remCalc(16),
        },
        modalContent: {
            borderRadius: 'xl',
            background: 'background.base.default',
            w: remCalc(370),
            paddingX: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            paddingY: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            margin: '0',
            maxHeight: '100%',
            minHeight: 'auto',
            sx: {
                border: `${remCalc(1)} solid border.neutral.highlight !important`,
                backdropFilter: 'blur(calc(var(--sm, 8px) / 2))',
                WebkitBackdropFilter: 'blur(calc(var(--sm, 8px) / 2))',
                boxShadow:
                    '0 0 0 1px var(--chakra-colors-border-neutral-highlight), 0 4px 8px 0 var(--chakra-shadows-neutral-xs), 0 6px 23px 0 var(--chakra-shadows-neutral-xs) !important',
            },
        },

        cartProduct: {
            padding: {base: `${remCalc(16)} 0`, lg: `${remCalc(20)} 0`},
            alignItems: 'center',
            gap: {base: remCalc(8), lg: remCalc(66)},
            flexDirection: {base: 'column', md: 'row', lg: 'row'},
            justifyContent: 'center',
            display: 'block',
        },
        cartProductList: {
            flexDirection: 'column',
            gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            width: '100%',
        },
        productStack: {
            alignItems: {base: 'flex-start', md: 'center', lg: 'center'},
            justifyContent: 'flex-start',
            gap: {base: remCalc(12), lg: remCalc(12)},
            padding: remCalc(0),
        },
        productContentContainer: {
            flexDirection: 'column',
            alignContent: 'flex-start',
            justifyContent: 'flex-start',
            gap: {base: remCalc(4), lg: remCalc(4)},
        },
        dragHandle: {
            alignSelf: 'center',
            width: remCalc(60),
            height: remCalc(5),
            marginBottom: remCalc(12),
            borderRadius: 'full',
            backgroundColor: '#D9D9D9',
        },
        restCartItemsContainer: {
            flexDirection: 'column',
            gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            width: '100%',
        },
        itemsLoadingContainer: {
            justifyContent: 'center',
            alignItems: 'center',
            padding: remCalc(24),
        },
        productHeader: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        productImageContainer: {
            minWidth: 'fit-content',
        },
        productImage: {
            boxSize: {base: remCalc(40), lg: remCalc(40)},
            objectFit: 'cover',
            borderRadius: 'medium-1',
        },
        productDetails: {
            flexDirection: {base: 'column', lg: 'row'},
            gap: {base: remCalc(8), lg: remCalc(66)},
            width: '100%',
            justifyContent: 'space-between',
        },
        modalBody: {
            gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            display: 'flex',
            flexDirection: 'column',
            paddingX: remCalc(0),
            paddingY: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
        },
        pricingOuterContainer: {
            flexDirection: 'column',
            gap: {base: 'xxxsmall.base', md: 'xxxsmall.md', lg: 'xxxsmall.lg', xl: 'xxxsmall.xl'},
        },
        pricingInnerContainer: {
            flexDirection: 'row',
            gap: {base: 'xxxsmall.base', md: 'xxxsmall.md', lg: 'xxxsmall.lg', xl: 'xxxsmall.xl'},
            alignItems: 'center',
            justifyContent: 'flex-start',
            w: '100%',
        },
        currentPrice: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        listPrice: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.subtle',
        },
        discount: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.subtle',
        },
        warrantyImageContainer: {
            width: remCalc(40),
            height: remCalc(40),
            borderRadius: 'medium-1',
            bg: 'background.base.under',
            alignItems: 'center',
            justifyContent: 'center',
        },
        warrantyIcon: {
            width: remCalc(16),
            height: remCalc(16),
            color: 'foreground.neutral.default',
        },
        modalFooter: {
            flexDirection: 'column',
            w: '100%',
            justifyContent: 'center',
            alignItems: 'flex-start',
            paddingTop: {
                base: 'xsmall.base',
                md: 'xsmall.md',
                lg: 'xsmall.lg',
                xl: 'xsmall.xl',
            },
            paddingBottom: remCalc(0),
            paddingX: remCalc(0),
            borderTop: '1px solid var(--chakra-colors-border-neutral-subtle)',
            gap: remCalc(16),
        },
        goToCartButton: {
            w: '100%',
        },
        goToCartButtonIcon: {
            width: remCalc(16),
            color: 'foreground.neutral.default',
            fill: 'none',
        },
        itemsInCartContainer: {
            gap: remCalc(3),
        },
        itemsInCartText: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
        },

        bundleFreeGiftLabel: {
            backgroundColor: '#0C2340',
            color: 'white',
            padding: '6px 8px',
            textStyle: 'body-xsmall',
            fontWeight: 'bold',
            w: 'fit-content',
            whiteSpace: 'nowrap',
        },
        bundleProductListPrice: {
            textDecoration: 'line-through',
            color: 'text.secondary',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        bundleProductDetailPrice: {
            color: 'text.default',
            textStyle: 'body-medium',
            fontWeight: 'normal',
        },
        bundleProductPriceContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(3),
        },

        // buttonsStack: {
        //     w: 'full',
        //     gap: remCalc(24),
        //     justifyContent: 'center',
        // },
        // footerButtonStack: {
        //     w: 'full',
        //     gap: remCalc(16),
        //     justifyContent: 'center',
        // },
        // pricingAlignment: {
        //     textAlign: {base: 'start', lg: 'end'},
        //     justifyContent: {base: 'flex-start', lg: 'flex-end'},
        // },
        // stickyButton: {
        //     position: 'sticky',
        //     bottom: 0,
        //     zIndex: 1000,
        //     w: 'full',
        //     pt: remCalc(16),
        //     pb: {base: 0, lg: remCalc(16)},
        //     display: {base: 'flex', lg: 'none'},
        // },
    },
    variants: {
        'cart-product-item': {
            pricingInnerContainer: {
                justifyContent: 'flex-end',
            },
        },
    },
}
